(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var drawer = document.querySelector('[data-pip-mobile-drawer]');
  if (!drawer) return;

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-pip-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-pip-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  // Close drawer on link click
  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeDrawer);
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-products-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(viewport) {
    if (viewport.dataset.pipCarouselReady) return;
    viewport.dataset.pipCarouselReady = '1';

    var track = viewport.querySelector('[data-pip-carousel-track]');
    var prev = viewport.querySelector('[data-pip-carousel-prev]');
    var next = viewport.querySelector('[data-pip-carousel-next]');
    if (!track) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var originals = Array.prototype.slice.call(track.children);
    var setW = 0;      // width of one full set of items
    var looped = false;

    function step() {
      var first = track.querySelector('.pip-carousel__item');
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    // Build a seamless loop: 3 identical sets, park in the middle one. Teleporting
    // by exactly one set width lands on identical content, so the jump is invisible.
    // Product-card interactions bind via document-level delegation, so clones work.
    function buildLoop() {
      // Only loop when the content actually overflows the viewport.
      if (track.scrollWidth <= track.clientWidth + 4) return false;
      for (var pass = 0; pass < 2; pass++) {
        originals.forEach(function (node) {
          var c = node.cloneNode(true);
          c.setAttribute('data-pip-clone', '');
          track.appendChild(c);
        });
      }
      looped = true;
      // Re-sync wishlist heart state onto the clones (cosmetic).
      try { document.dispatchEvent(new Event('filter:update')); } catch (e) {}
      measure();
      // Start in the middle set.
      setSnap(false);
      track.scrollLeft = setW;
      requestAnimationFrame(function () { setSnap(true); });
      return true;
    }

    function measure() { setW = track.scrollWidth / 3; }

    function setSnap(on) { track.style.scrollSnapType = on ? '' : 'none'; }

    // Keep the scroll position parked within the middle set (teleport while idle).
    function normalize() {
      if (!looped || !setW) return;
      var x = track.scrollLeft;
      // Middle set occupies [setW, 2*setW). Only teleport when we've crossed
      // fully out of it, and only by whole set widths (identical content).
      if (x < setW || x >= setW * 2) {
        var target = ((x - setW) % setW + setW) % setW + setW;
        setSnap(false);
        track.scrollLeft = target;
        requestAnimationFrame(function () { setSnap(true); });
      }
    }

    function advance(dir) {
      normalize();               // teleport first (while stationary), so the smooth move never straddles a jump
      track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function updateArrows() {
      if (looped) {              // continuous: both arrows always available
        if (prev) prev.hidden = false;
        if (next) next.hidden = false;
        return;
      }
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { advance(-1); });
    if (next) next.addEventListener('click', function () { advance(1); });

    // Normalize after the user stops scrolling/swiping (debounced idle).
    var idle;
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
      clearTimeout(idle);
      idle = setTimeout(normalize, 140);
    }, { passive: true });
    window.addEventListener('resize', function () { measure(); updateArrows(); });

    // ---- autoplay ----
    var wantAutoplay = viewport.dataset.autoplay === 'true' && !reduceMotion;
    var interval = Math.max(2, parseFloat(viewport.dataset.autoplaySeconds) || 4) * 1000;
    var timer = null;
    function play() { if (wantAutoplay && looped && !timer) timer = setInterval(function () { advance(1); }, interval); }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }

    // Pause on hover / focus / touch; resume when the pointer leaves.
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { viewport.addEventListener(ev, pause, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { viewport.addEventListener(ev, play); });
    // Pause when the section scrolls out of view.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? play() : pause(); });
      }, { threshold: 0.2 }).observe(viewport);
    }

    // Init: image widths need a tick to settle before measuring.
    requestAnimationFrame(function () {
      buildLoop();
      updateArrows();
      play();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pip-carousel]').forEach(initCarousel);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  // Re-init when re-rendered in the theme editor
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-shoppable"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStage(stage) {
    if (stage.dataset.pipShopReady) return;
    stage.dataset.pipShopReady = '1';

    var toggles = stage.querySelectorAll('[data-pip-spot-toggle]');
    toggles.forEach(function (btn) {
      var spot = btn.closest('.pip-shop__spot--dot');
      btn.addEventListener('click', function (e) {
        var isOpen = spot.hasAttribute('data-open');
        // close siblings
        stage.querySelectorAll('.pip-shop__spot--dot[data-open]').forEach(function (s) {
          if (s !== spot) { s.removeAttribute('data-open'); s.querySelector('[data-pip-spot-toggle]').setAttribute('aria-expanded', 'false'); }
        });
        if (isOpen) { spot.removeAttribute('data-open'); btn.setAttribute('aria-expanded', 'false'); }
        else { spot.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); }
      });
    });

    // click outside closes any open dot
    document.addEventListener('click', function (e) {
      if (stage.contains(e.target)) return;
      stage.querySelectorAll('.pip-shop__spot--dot[data-open]').forEach(function (s) {
        s.removeAttribute('data-open'); s.querySelector('[data-pip-spot-toggle]').setAttribute('aria-expanded', 'false');
      });
    });
  }
  function initAll() { document.querySelectorAll('[data-pip-shoppable]').forEach(initStage); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pip-video').forEach(function (section) {
    var btn = section.querySelector('[data-pip-video-toggle]');
    var video = section.querySelector('video.pip-video__media');
    if (!btn || !video) return;
    btn.addEventListener('click', function () {
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
        section.classList.remove('pip-video--paused');
        btn.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        section.classList.add('pip-video--paused');
        btn.setAttribute('aria-label', 'Play video');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
